function ProductImageStick() {
  const init = () => {
    stickImage();
  };
  const stickImage = () => {
    const $imgContainer = document.querySelector('.product-first-row-left-col.pdp-left-col');

    const isMobile = window.innerWidth >= 1024;

    if (!isMobile || !$imgContainer) return;

    const options = {
      root: null,
      threshold: [0.1, 1],
      intersect: 'both',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          $imgContainer.classList.add('sticky-img');
        } else {
          $imgContainer.classList.remove('sticky-img');
        }
      });
    }, options);

    observer.observe($imgContainer);
  };
  init();
}

ProductImageStick();
